import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Box, Flex } from '@olist/united';

const FIELD_MARGIN = themeGet('space.2');

export const FieldPair = styled(Flex)`
  flex-wrap: wrap;
  margin: -${FIELD_MARGIN}px;
  margin-top: ${themeGet('space.4')}px;
`;

export const FieldWrapper = styled(Box)`
  margin: ${FIELD_MARGIN}px;
  max-width: 320px;
  width: 100%;
`;
